<template>
  <div class="container">
    <div class="columns">
      <div class="column is-half is-offset-one-quarter has-text-centered">
        <span class="mdi mdi-account-circle mdi-72px" />
        <b-notification
          type="is-warning is-light"
          aria-close-label="Close notification"
          role="alert"
          :closable="false"
        >
          <strong> Usuario no configurado </strong>
          <dl>
            <dt>Usuario</dt>
            <dd>{{ sesion.nombreUsuario }}</dd>
            <dt>Nombre</dt>
            <dd>{{ sesion.nombre }}</dd>
          </dl>
          <strong>
            Debe contactarse con el encargado de MOPI en su bodega
          </strong>
        </b-notification>

        <b-button type="is-info" @click="logoutHandle"> Reintentar </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('sesion', ['sesion'])
  },
  methods: {
    logoutHandle() {
      this.$store.dispatch('sesion/logout').then(() => {
        this.$router.replace({ name: 'login' })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  margin-top: 30px;
}
.mdi-72px {
  font-size: 72px;
  :before {
    font-size: 72px;
  }
}
</style>
